<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      {{ $t('Company information on invoices') }}
    </div>
    <div class="panel-body">
      <h4 class="text-center m-b-20 m-t-20">
        {{ $t('Company information on invoices') }}
      </h4>

      <div class="form-group">
        <div class="checkbox col-md-offset-4">
          <label>
            <input
              v-model="disableBillingInformation"
              name="disable_billing_information"
              type="checkbox"
              value="true"
            />
            <i class="input-helper" />
            {{ $t('Same as my company account details') }}
          </label>
        </div>
      </div>

      <div v-show="!disableBillingInformation">
        <div class="form-group">
          <label for="billingCompanyName" class="col-md-4 col-xs-4 control-label">
            {{ $t('Company name') }}
          </label>
          <div class="col-md-6 col-xs-8">
            <input
              id="billingCompanyName"
              :placeholder="$t('Enter your company name')"
              :value="persistentCompanyName.value"
              required="required"
              name="billing_company_name"
              type="text"
              class="form-control"
            />
          </div>
        </div>

        <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
        <edit-location
          :persistent-address="{
            fieldName: 'billing_address',
            ...persistentAddress,
          }"
          :persistent-zipcode="{
            fieldName: 'billing_zipcode',
            ...persistentZipcode,
          }"
          :persistent-city="{ fieldName: 'billing_city', ...persistentCity }"
          :persistent-country="{
            fieldName: 'billing_country',
            ...persistentCountry,
          }"
          :persistent-state="{ fieldName: 'billing_state', ...persistentState }"
          :show-address-visibility-label="false"
        />
      </div>

      <div class="form-group">
        <div class="col-md-6 col-md-offset-4">
          <SubmitButton :text="$t('Save')" auto-submit />
        </div>
      </div>
    </div>
    <!--panel body-->
  </div>
  <!-- panel -->
</template>

<script>
import SubmitButton from '@/components/SubmitButton.vue'

export default {
  name: 'EditCompanyBillingInformationPanel',
  components: { SubmitButton },
  props: {
    persistentCompanyName: {
      type: Object,
      required: true,
    },
    persistentAddress: {
      type: Object,
      required: true,
    },
    persistentZipcode: {
      type: Object,
      required: true,
    },
    persistentCity: {
      type: Object,
      required: true,
    },
    persistentCountry: {
      type: Object,
      required: true,
    },
    persistentState: {
      type: Object,
      required: true,
    },
    showAddressVisibilityLabel: {
      type: Boolean,
      default: false,
    },
    persistentEnableBillingInformation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      disableBillingInformation: !this.persistentEnableBillingInformation.value,
    }
  },
}
</script>

<style scoped></style>
